import { Request } from "@xt/xtbase";

const { XtAxios4 } = Request;

/** 与 user-center About / Follow us 一致 — 走 Next rewrite 相对路径 */
const BASE = "/xt-app/public/social-media-config";
const DEFAULT_TENANT_ID = "1";

/** GET /xt-app/public/social-media-config/list */
export function getSocialMediaList(config) {
  const tenantId = process.env.NEXT_PUBLIC_TENANT_ID || DEFAULT_TENANT_ID;
  return XtAxios4.get(`${BASE}/list`, {
    isAutoPopError: false,
    ...config,
    headers: {
      "tenant-id": tenantId,
      ...config?.headers,
    },
  });
}

export function normalizeSocialMediaList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.list)) return data.list;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.result)) return data.result;
  return [];
}

/** 顶栏 Help + Footer Community 共用：整页只请求一次 */
let socialMediaCache = null;
let socialMediaInflight = null;

export function loadSocialMediaList(config) {
  if (socialMediaCache) return Promise.resolve(socialMediaCache);
  if (socialMediaInflight) return socialMediaInflight;

  socialMediaInflight = getSocialMediaList(config)
    .then((data) => {
      socialMediaCache = normalizeSocialMediaList(data);
      socialMediaInflight = null;
      return socialMediaCache;
    })
    .catch((err) => {
      socialMediaInflight = null;
      throw err;
    });

  return socialMediaInflight;
}
